// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100%;
  filter: brightness(18%);
  object-fit: cover;
}
@media (max-width: 1024px) {
  .login img {
    position: fixed;
  }
}
.login__card {
  padding: 25px 25px;
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.login__title {
  font-size: 27px;
  font-weight: 500;
  text-align: center;
  color: white;
  margin-bottom: 15px;
}
.login__content {
  display: flex;
  justify-content: center;
}
.login .phone__input, .login .password__input {
  width: 400px;
  background-color: transparent;
  border: none;
  border-bottom: 2px solid white;
  color: white;
  left: 50%;
  margin-bottom: 15px;
  outline: none;
}
@media (max-width: 450px) {
  .login .phone__input, .login .password__input {
    width: 350px;
  }
}
.login .phone__input::placeholder, .login .password__input::placeholder {
  font-size: 18px;
  font-weight: 400;
  color: white;
}
.login__label {
  margin-bottom: 15px;
  color: white;
  font-size: 15px;
  font-weight: 400;
}
.login__button {
  width: 400px;
  display: block;
  margin: 0 auto;
  border-radius: 10px;
  border: 2px solid white;
  background-color: white;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  color: rgb(7, 7, 7);
}
@media (max-width: 450px) {
  .login__button {
    width: 350px;
  }
}
.login__button:hover {
  background-color: transparent;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/Login/style.scss"],"names":[],"mappings":"AACQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;AAAZ;AACY;EAVJ;IAWQ,eAAA;EAEd;AACF;AACI;EACI,kBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;AACR;AAEI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAAR;AAGI;EACI,aAAA;EACA,uBAAA;AADR;AAII;EACI,YAAA;EACA,6BAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;AAFR;AAGQ;EATJ;IAUQ,YAAA;EAAV;AACF;AAEQ;EACI,eAAA;EACA,gBAAA;EACA,YAAA;AAAZ;AAOI;EACG,mBAAA;EACC,YAAA;EACA,eAAA;EACA,gBAAA;AALR;AASI;EACI,YAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAPR;AAQQ;EAXJ;IAYQ,YAAA;EALV;AACF;AAMQ;EACI,6BAAA;EACA,YAAA;AAJZ","sourcesContent":[".login {\n        img {\n            position: absolute; \n            top: 0; \n            left: 0; \n            right: 0;\n            bottom: 0;\n            height: 100vh;\n            width: 100%;\n            filter: brightness(18%);\n            object-fit: cover; \n            @media (max-width: 1024px) {\n                position: fixed;\n            }\n        }\n\n    &__card {\n        padding: 25px 25px;\n        position: fixed;\n        top: 40%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        cursor: pointer;\n    }\n    \n    &__title {\n        font-size: 27px;\n        font-weight: 500;\n        text-align: center;\n        color: #ffff;\n        margin-bottom: 15px;\n    }   \n\n    &__content {\n        display: flex;\n        justify-content: center;\n    }\n\n    .phone__input, .password__input {\n        width: 400px;\n        background-color: transparent;\n        border: none;\n        border-bottom: 2px solid #ffff;\n        color: #ffff;\n        left: 50%;\n        margin-bottom: 15px;\n        outline: none;\n        @media (max-width: 450px) {\n            width: 350px;\n        }\n\n        &::placeholder {\n            font-size: 18px;\n            font-weight: 400;\n            color:#ffff;\n            \n        }\n    }\n\n    \n\n    &__label {\n       margin-bottom: 15px;\n        color: #ffff;\n        font-size: 15px;\n        font-weight: 400;\n        \n    }\n\n    &__button {\n        width: 400px;\n        display: block;\n        margin: 0 auto;\n        border-radius: 10px;\n        border: 2px solid #ffff;\n        background-color: #ffff;\n        font-size: 18px;\n        font-weight: 600;\n        text-align: center;\n        color: rgb(7, 7, 7);\n        @media (max-width: 450px) {\n            width: 350px;\n        }\n        &:hover {\n            background-color: transparent;\n            color: #ffff;\n        }\n    }\n    \n}\n\n\n\n   \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
